const NotificationNavRoutes = [
  {
    path: '/notifications',
    component: () => import('@/components/Routable.vue'),
    children: [
      {
        path: '/',
        name: 'Notifications',
        component: () => import('@/views/Notification.vue'),
        meta: { requiresAuth: true, footerIcon: 'notifications', titleName: route => {} }
      },
      {
        path: ':notifId/posts/:postId',
        name: 'SinglePostNotif',
        component: () => import('@/views/singlePost.vue'),
        meta: {
          requiresAuth: true,
          footerIcon: 'notifications',
          titleName: route => 'Noticia'
        }
      }
    ]
  }
]
export default NotificationNavRoutes



// WEBPACK FOOTER //
// ./src/router/notifications.js